<template>
  <div class="row" v-if="exibirDetalhesTomador">
    <div class="col-md-10 mb-2">
      <Panel :toggleable="true" :header="headerDetalhamento">
        <div class="row">
          <div class="col-md-12">
            <template v-if="pessoa.tipo == 'J'">
              <b>Nome Fantasia:</b>
              {{pessoa.nomeFantasia}}
            </template>
          </div>
          <div class="col-md-12">
            <b>Endereço:</b>
            {{pessoa.detailEndereco}}
          </div>
        </div>

        <hr />

        <div class="row">
          <div class="col-lg-4 mb-1">
            <b>{{ pessoa.tipo == 'X' ? 'NIF:' : pessoa.tipo == 'F' ? 'CPF:' : 'CNPJ:' }}</b>
            {{pessoa.documento}}
            <br />
            <template v-if="pessoa.tipo == 'F'">
              <b>RG:</b>
              {{pessoa.rg}}
              <br />
            </template>
            <template v-if="pessoa.tipo != 'X'">
              <b>Inscrição Municipal:</b>
              {{pessoa.inscMunic}}
              <br />
              <b>Inscrição Estadual:</b>
              {{pessoa.inscEstadual}}
            </template>
          </div>

          <div class="col-lg-4 mb-1">
            <b>E-mail:</b>
            {{pessoa.email}}
            <br />
            <b>Site:</b>
            {{pessoa.site}}
          </div>

          <div class="col-lg-4 col-md-auto mb-1">
            <b>Telefone:</b>
            {{pessoa.telefone}}
            <br />
            <b>Celular:</b>
            {{pessoa.celular}}
          </div>
        </div>
      </Panel>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetalhesContribuinte",

  props: {
    tipoEmissao: String
  },

  data() {
    return {};
  },

  computed: {
    pessoa() {
      if (this.tipoEmissao === "I") {
        return this.$parent.selectedPessoaIntermediario;
      }else if (this.tipoEmissao === "D") {
        return this.$parent.selectedPessoaDestinatario;
      } else {
        return this.$parent.selectedPessoa;
      }
    },

    exibirDetalhesTomador() {
      return this.pessoa && this.pessoa.id ? true : false;
    },

    headerDetalhamento() {
      return (
        ("Dados do ") +
        (this.tipoEmissao == "I" ? "Intermediário" : this.tipoEmissao == "D" ? "Destinatário" : this.tipoEmissao == "T" ? "Prestador" : "Tomador")
      );
    }
  }
};
</script>

<style>
</style>